import React from "react";
import ComingSoon from "./ComingSoon";

const SubBroker = () => <ComingSoon title="Sub Broker" />;

export default SubBroker;
